var React = require('react');

function IconMultiples (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","d":"M16,14.5469248 L16,20.039 L12.994716,21.7629404 C12.3786051,22.1161526 11.6213949,22.1161526 11.005284,21.7629404 L8,20.039 L8,14.5469248 L12,16.8139248 L16,14.5469248 Z M12.994716,2.26490918 L19.994716,6.27796237 C20.6164941,6.63442359 21,7.29634363 21,8.01305319 L21,16.0147964 C21,16.731506 20.6164941,17.393426 19.994716,17.7498872 L18,18.892 L18,11.0139248 L12,14.4419248 L6,11.0139248 L6,18.893 L4.00528404,17.7498872 C3.38350595,17.393426 3,16.731506 3,16.0147964 L3,8.01305319 C3,7.29634363 3.38350595,6.63442359 4.00528404,6.27796237 L11.005284,2.26490918 C11.6213949,1.91169694 12.3786051,1.91169694 12.994716,2.26490918 Z"}));
}

IconMultiples.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconMultiples;

IconMultiples.default = IconMultiples;
